import React from 'react';
import { Accordion, Box } from '@drone-js/core';
import { ItineraryStepperComponent } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStepper';
import { StructuredItineraryProps } from 'component/page/detail/Itineraries/StructuredItinerary/StructuredItinerary.selectors';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

const ItineraryMultiDayComponent: React.FC<{ itineraryList: StructuredItineraryProps[]; contentLocale: string }> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    if (!props.itineraryList) {
        return null;
    }

    return (
        <Box pt="8">
            {props.itineraryList.map((itinerary, index) => (
                <Accordion data-testid="multi-day-itinerary" key={index} actionType="chevron-icon" level={4} contentSummary={itinerary.title || cms[239747]}>
                    <ItineraryStepperComponent dayItinerary={itinerary.days} dayDescription={itinerary.description} contentLocale={props.contentLocale} />
                </Accordion>
            ))}
        </Box>
    );
};
ItineraryMultiDayComponent.displayName = 'ItineraryMultiDayComponent';

export default ItineraryMultiDayComponent;
